var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonei(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 141 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.8.9h8.6l7 11.3 7-11.3H32v29.3h-8.1V13.3l-7.5 11.5h-.2L8.8 13.4v16.7h-8V.9zm51 22.5c1.1 0 2.1-.2 3.1-.6.9-.4 1.7-1 2.3-1.7s1.1-1.5 1.5-2.5c.4-.9.5-2 .5-3v-.1c0-1.1-.2-2.1-.5-3-.4-.9-.9-1.8-1.5-2.5-.7-.7-1.5-1.3-2.4-1.7-.9-.4-1.9-.6-3.1-.6-1.1 0-2.1.2-3 .6-.9.4-1.7 1-2.3 1.7-.7.7-1.2 1.5-1.5 2.5-.3.9-.5 2-.5 3v.1c0 1.1.2 2.1.5 3 .4.9.9 1.8 1.5 2.5.7.7 1.4 1.3 2.4 1.7.9.4 1.9.6 3 .6zm-.1 7.3c-2.3 0-4.3-.4-6.3-1.2-1.9-.8-3.6-1.9-5-3.2-1.4-1.4-2.5-3-3.3-4.8s-1.2-3.8-1.2-5.9v-.1c0-2.1.4-4.1 1.2-5.9.8-1.9 1.9-3.5 3.3-4.8 1.4-1.4 3.1-2.5 5-3.3s4-1.2 6.3-1.2S56 .7 58 1.5c1.9.8 3.6 1.9 5 3.2 1.4 1.4 2.5 3 3.3 4.8s1.2 3.8 1.2 5.9v.1c0 2.1-.4 4.1-1.2 5.9-.8 1.9-1.9 3.5-3.3 4.8-1.4 1.4-3.1 2.5-5 3.3s-4 1.2-6.3 1.2zM71.8.9h7.6l12 15.5V.9h8v29.3h-7.1l-12.5-16v16h-8V.9zm32.8 0h23.5v6.9h-15.5v4.4h14v6.4h-14v4.6h15.7v6.9h-23.7V.9zm28 0h8.1v29.3h-8.1V.9z",
    fill: "#00c1b1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonei);
export default __webpack_public_path__ + "static/media/monei.a95c7d95916c720695c9708456cfcf7e.svg";
export { ForwardRef as ReactComponent };